import { useSearchParams } from "react-router-dom";
import { AdminShell } from "@/components/admin/AdminShell";
import PopUpManagement from "@/components/admin/PopUpManagement";

export default function PopupPage() {
  const [params, setParams] = useSearchParams();
  const focusRaw = params.get("focus");
  let focusItem: { type: "popup_vendor" | "popup_ticket"; id: string } | null = null;
  if (focusRaw) {
    if (focusRaw.startsWith("vendor:")) focusItem = { type: "popup_vendor", id: focusRaw.slice(7) };
    else if (focusRaw.startsWith("ticket:")) focusItem = { type: "popup_ticket", id: focusRaw.slice(7) };
  }
  return (
    <AdminShell section="popup">
      <div className="container mx-auto p-4 md:p-6 space-y-4">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground">Pop-Up Management</h1>
          <p className="text-sm text-muted-foreground">Vendors, early bird tickets, and communications.</p>
        </div>
        <PopUpManagement
          focusItem={focusItem}
          onFocusHandled={() => {
            const next = new URLSearchParams(params);
            next.delete("focus");
            setParams(next, { replace: true });
          }}
        />
      </div>
    </AdminShell>
  );
}
